module.exports = __webpack_public_path__ + "static/media/hotel_lobby_mural_initial_concept_2020.99215ff3.webp";